// extracted by mini-css-extract-plugin
export default {"container":"svg_container__8NBtv","svg_container":"svg_svg_container__WOG7q","curve1":"svg_curve1__Wopi8","curve2":"svg_curve2__RaM-H","mtt":"svg_mtt__PtP3k"};